import React, { useEffect } from 'react'
import { useState } from 'react'

import { faCaretRight, faCaretLeft, faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import ReactPlayer from 'react-player/youtube'
import './trailer.css'
// import ReactPlayer from 'react-player'
function Trailer() {

  const [mute, setMute] = useState(true);//음소거 상태
  const [muteIcon, setMuteIcon] = useState(faVolumeMute); //mute 아이콘
  const [videoNum, setVideoNum] = useState(0);

  /*prev, next버튼 클릭 */

  function btnClick(e) {
    
    if (e === -1) { //이전 버튼
      if (videoNum === 0) { //첫번째 유튜브
        setVideoNum(4);
        // channel_number.innerHtml = '03';
      } else {
        setVideoNum(videoNum + e);
      }
    } else if (e == 1) {
      if (videoNum === 4) {
        setVideoNum(0);
      } else {
        setVideoNum(videoNum + e);
      }
    }
  }
  // useEffect(()=>{ 안되네 ;;
  //   let channel_number = document.querySelector(".channel_number");
  //   channel_number.innerHtml = `0${videoNum}`;
  // })


  function muteClick() {
    if (!mute) {
      setMuteIcon(faVolumeMute)
      setMute(true)
    } else {
      setMuteIcon(faVolumeUp)
      setMute(false)
    }
  }
  
  // useEffect(()=>{
  //   muteClick();
  //   console.log( JSON.stringify(Video[0]));
  // },[] )


 
  return (
    <section>
      <div className="btn_box">
        {/* 이전 버튼 */}
        <button className='prev' onClick={() => btnClick(-1)}>
          <FontAwesomeIcon icon={faCaretLeft} />
          <span>Prev</span>
        </button>
        {/* 가운데 Channel 숫자, 음소거 아이콘 */}
        <h2>Channel
          <span className="channel_number">
            {Video[videoNum].id}
          </span>
        </h2>
        {/* 음소거 */}
        <button className='mute' onClick={muteClick}>
          <span className="btn_mute">
            <FontAwesomeIcon icon={muteIcon} />
          </span>
        </button>

        {/* 다음버튼 */}
        <button className='next' onClick={() => btnClick(1)}>
          <FontAwesomeIcon icon={faCaretRight} />
          <span>Next</span>
        </button>

      </div>

      {/* 유튜브 영상 */}
      <div id="player">
        <ReactPlayer
          url={Video[videoNum].url}
          playing={true}
          volume={.7}
          muted={mute}
          autoPlay={true}
          loop={true}
        />
      </div>

    </section>
  )
}

export default Trailer


// trailer에서 바로 끌어다 쓸 수 있는 듯
/*유튜브 비디오 영상 배열 객체 */
const Video = [
  { id: '00', url: 'https://www.youtube.com/watch?v=qELSSAspRDI' },
  { id: '01', url: 'https://www.youtube.com/watch?v=sj9J2ecsSpo' },
  { id: '02', url: 'https://www.youtube.com/watch?v=UBhlqe2OTt4' },
  { id: '03', url: 'https://youtu.be/XSvsmteRf5k?si=vusv3rHpgPOwSiZq' }, //파워드라몬
  { id: '04', url: 'https://youtu.be/wA6M7m_2kz8?si=koLQ46reGBdbtP42' }, //워그레이몬
]